<template>
	<div>
		<!-- eslint-disable-next-line vue/no-mutating-props -->
		<!-- <v-dialog v-if="errorMsgDialog" v-model="errorMsgDialog"
			:max-width="size === 'sm' ? 295 : 364"
			max-height="90vh"
			:retain-focus="false"
			persistent>
			<div :class="`${theme}-theme`" @click="cancelEvent" @dblclick="cancelEvent">
				<div class="popup pa-0">
					<div class="popup-header pa-0 text-center">
						<h4 class="fs--24 fw--600 popup-header-text pt-9">Oops!</h4>
					</div>
					<div class="popup-body">
						<div class="popup-content pt-0">
							<div class="text-center">
								<img src="@/assets/images/error.png" width="60%" alt="Error" height="60%" />
							</div>

							<div class="d-flex align-center justify-center mb-3">
								<h4 class="fs--12 fw--600 popup-footer-text">
									{{ errorMessage }}
								</h4>
							</div>

							<v-btn
								block
								color="primary"
								class="fs--15 fw--600 mt-4 action-btn text-uppercase"
								@click="reload">
								Reload
							</v-btn>
						</div>
					</div>
				</div>
			</div>
		</v-dialog> -->

		<PopupDialog v-if="errorMsgDialog">
			<template #popupHeader>
				<div class="popup-header pa-0 text-center">
					<h4 class="fs--24 fw--600 popup-header-text pt-9">Oops!</h4>
				</div>
			</template>
			<template #popupBody>
				<div class="popup-body">
					<div class="popup-content pt-0">
						<div class="text-center">
							<img src="@/assets/images/error.png" width="60%" alt="Error" height="60%" />
						</div>

						<div class="d-flex align-center justify-center mb-3">
							<h4 class="fs--12 fw--600 popup-footer-text">
								{{ errorMessage }}
							</h4>
						</div>

						<v-btn block color="primary" class="fs--15 fw--600 mt-4 action-btn text-uppercase" @click="reload">
							Reload
						</v-btn>
					</div>
				</div>
			</template>
		</PopupDialog>
	</div>
</template>

<script>
import { useStore } from '@/store';
import { computed } from 'vue';
import { mdiClose } from '@mdi/js';
import PopupDialog from '@/components/panel/PopupDialog.vue';

export default {
	components: {
		PopupDialog
	},
	props: {
		errorMsgDialog: {
			type: Boolean,
			default: false,
		},
		errorMessage: {
			type: String,
			default: '',
		},
	},
	emits: ['onClose'],
	setup(_, ctx) {
		const store = useStore();

		const theme = computed(() => store.state.theme);
		const size = computed(() => store.state.size);

		const close = () => {
			ctx.emit('onClose');
		};

		const reload = () => {
			ctx.emit('onReloadExt');
		};

		const cancelEvent = event => {
			event.stopImmediatePropagation();
		};

		return {
			reload,
			theme,
			size,
			close,
			cancelEvent,
			icons: {
				mdiClose,
			},
		};
	},
};
</script>
